import RiskProfileItem from '@/types/risk-profile-item';
import * as deprecated from '../../redux/modules/usage-log-deprecated';
import * as UsageLogService from './usage-log-new';

// New
export const {
  addUsageLog,
  logAttachOmniRiskProfileToComparison,
  logCancelAIStatementReaderProcess,
  logDismissUnlockAIStatementReaderFromMarketingBanner,
  logDisplayAIStatementReaderMarketingBanner,
  logDocumentsProcessedByAIStatementReader,
  logDownloadProposal,
  logErrorInAIStatementReader,
  logHistoricalScenariosUsage,
  logSaveAIStatementPortfolio,
  logUnlockAIStatementReaderFromMarketingBanner,
} = UsageLogService;

// Deprecated
export const logNewComparison = () => deprecated.logNewComparison();

export const logAddToComparison: typeof deprecated.logAddToComparison = (...items) => deprecated.logAddToComparison(...items);

export const logRemoveFromComparison: typeof deprecated.logRemoveFromComparison = (...items) => deprecated.logRemoveFromComparison(...items);

export const logAttachRiskProfile: typeof deprecated.logAttachRiskProfile = (profile: RiskProfileItem) => deprecated.logAttachRiskProfile(profile);

export const logNewPortfolio: typeof deprecated.logNewPortfolio = () => deprecated.logNewPortfolio();

export const logPortfolioHoldingEvent: typeof deprecated.logPortfolioHoldingEvent = (type, holding, portfolio) =>
  deprecated.logPortfolioHoldingEvent(type, holding, portfolio);

export const logAddToPortfolio: typeof deprecated.logAddToPortfolio = (holding, portfolio) => deprecated.logAddToPortfolio(holding, portfolio);

export const logRemoveFromPortfolio: typeof deprecated.logRemoveFromPortfolio = (holding, portfolio) => deprecated.logRemoveFromPortfolio(holding, portfolio);

export const logAddComparisonMarkup: typeof deprecated.logAddComparisonMarkup = (category, field, type) =>
  deprecated.logAddComparisonMarkup(category, field, type);

export const logResetComparisonMarkup: typeof deprecated.logResetComparisonMarkup = () => deprecated.logResetComparisonMarkup();

export const logOpenHelpCenter: typeof deprecated.logOpenHelpCenter = () => deprecated.logOpenHelpCenter();
